import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { NiceModalComponent } from "components/context/NiceModalProvider";
import SnapshotList from "models/deals/SnapshotList";

export default NiceModal.create(({ id }) => {
  const modal = useModal();

  return (
    <NiceModalComponent open={modal.visible} onClose={modal.hide}>
      <SnapshotList companyId={id} onClose={modal.hide} />
    </NiceModalComponent>
  );
});
